import { z } from 'zod'
import { csrfTokenService } from '~/apps/csrf/CsrfTokenService'
import { getLangFallbackUrl } from '~/lang/utils/langfetch'
import { allocationAlertSchema, UserAllocationAlert } from './types'

const userAllocationAlertsResponseSchema = z.array(allocationAlertSchema)

export async function fetchUserAllocationAlerts(
  locale: string,
): Promise<UserAllocationAlert[]> {
  const response = await $fetch(
    getLangFallbackUrl(locale, '/_/users/allocation-alerts/'),
    {
      credentials: 'include',
    },
  )
  return userAllocationAlertsResponseSchema.parse(response)
}

export async function removeAllocationAlert(
  alertId: string,
  alertType: string,
) {
  const endpoint =
    alertType === 'allocation_alert'
      ? `/_/fallback/allocation_alerts/cancel/${alertId}/`
      : `/_/fallback/allocation-alerts-location/cancel/${alertId}/`
  const { csrfToken } = await csrfTokenService()
  return await $fetch(endpoint, {
    method: 'DELETE',
    headers: {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: Type csrfTokenService return value
      'X-CSRFToken': csrfToken,
    },
  })
}
